import {IconSize, IconStyle, ShieldIconSize} from '../../Icons/icon_types';
import ShieldCheckIcon from '../../Icons/icons/withSelectedState/shieldCheck';
import ShieldErrorIcon from '../../Icons/icons/withSelectedState/shieldError';

export type VerifiedIcons = 'error' | 'check';

export const verifiedIconMap: {
  [key in VerifiedIcons]: React.FC<{
    size: IconSize | ShieldIconSize;
    color: string;
    checkColor?: string;
    style: IconStyle;
    crossColor?: string;
  }>;
} = {
  ['error']: ShieldErrorIcon,
  ['check']: ShieldCheckIcon,
};

export type MiniCredentialCardProps = {
  id?: string;
  className?: string;
  issuer: {
    image?: string;
    name: string;
    failToLoadImageText?: string;
  };
  chip?: {
    text: string;
    color?: string;
    containerStyle?: any;
  };
  verifiedIcon?: VerifiedIcons;
  display?: {
    background_color?: string;
    text_color?: string;
    hasGradient?: boolean;
  };
  containerStyle?: any;
  onClick?: (x?: any) => void;
};
